export const hotList = [
  {
    id: 1,
    title: '顶流男演员恋情疑似实锤？同款外套与行程重合引全网考古',
    category: '恋情观察',
    heat: 9860,
    trend: 'up' as const,
    trendValue: '+12.4%',
    comments: 4521,
    publishedAt: '18 分钟前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20romantic%20rose%20petals%20floating%20over%20a%20soft%20warm%20coral%20gradient%20background%20with%20two%20distant%20intertwined%20silhouettes%2C%20editorial%20entertainment%20magazine%20cover%20style%2C%20vibrant%20coral%20and%20amber%20color%20grading%2C%20soft%20bokeh%20stage%20lights%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-01&orientation=landscape',
    summary:
      '有网友整理出两位艺人近半年的机场造型与行程时间线，发现多次出现同款单品与重叠城市，讨论在一夜之间冲上榜首。',
    tags: ['行程考古', '同款单品', '网友整理'],
    author: '瓜田小队长',
    content: [
      '事情的起点是一组机场路透。有网友发现，两位艺人在相隔不到两周的时间里，被拍到穿着同一款小众设计师外套，连袖口的定制细节都高度相似。这条对比图最初只在小范围流传，因为配文写得克制，反而让更多人加入了"考据"队伍。',
      '随后有人顺着时间线继续扒：两人在一段时间内先后出现在同一座城市，中间只隔了一天。支持者认为这是行程巧合，反对者则指出，那几天双方都没有公开的工作安排。围绕"是不是"的争论，很快从造型帖扩散到了各个平台的评论区。',
      '需要说明的是，到目前为止双方工作室均未回应，所谓"实锤"仍停留在网友的推理层面。我们也提醒各位：把路透图当作线索可以，把推测当作结论则大可不必。当事人是否愿意公开私人关系，本身也是他们的权利。',
    ],
    timeline: [
      { time: '3 天前', text: '首组同款外套对比图在小范围流传，配文标注"仅造型巧合讨论"。' },
      { time: '昨天 22:40', text: '有用户整理出完整行程时间线，帖文转发量突破五万。' },
      { time: '今天 09:15', text: '话题冲上瓜圈速报热度榜首位，双方工作室暂未回应。' },
    ],
  },
  {
    id: 2,
    title: '暑期档古装剧口碑逆袭：开分 6.2 一路涨到 8.1',
    category: '影视风向',
    heat: 9420,
    trend: 'up' as const,
    trendValue: '+9.8%',
    comments: 3860,
    publishedAt: '42 分钟前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20corridor%20in%20warm%20golden%20hour%20light%2C%20layered%20red%20lanterns%20and%20silk%20curtains%2C%20cinematic%20costume%20drama%20key%20art%20style%2C%20amber%20and%20deep%20red%20color%20grading%2C%20misty%20atmosphere%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-02&orientation=landscape',
    summary:
      '这部被吐槽"前八集劝退"的古装剧，靠中段的一场长镜头群像戏口碑翻盘，评分曲线成了今年暑期档最陡的一条。',
    tags: ['古装剧', '口碑反转', '长镜头'],
    author: '老瓜观察员',
    content: [
      '开播首日，这部剧的讨论几乎全是差评：滤镜过白、台词偏现代、支线推进拖沓。评分一度掉到 6.2，弹幕里"看不懂为什么这么拍"的疑问刷了满屏。平台的数据曲线也很难看，第三天播放量环比下滑明显。',
      '转折出现在第九集。一场持续近四分钟的群像长镜头，把三条时间线在一个空间里同时完成，镜头调度与配乐配合得相当克制。这段内容被剪成多个版本在社交平台流传，不少原本弃剧的观众表示"为了这一段重新开始看"。',
      '到第十集更新后，评分已经回升到 8.1。导演在采访中提到，前八集是刻意做的"信息埋线"，观众需要带着疑问往下走。这个解释是否成立，恐怕每个人心里都有不同答案，但至少从数据上看，它确实赢回了一批观众。',
    ],
    timeline: [
      { time: '开播首日', text: '首播两集上线，评分 6.2，滤镜与台词成为主要争议点。' },
      { time: '第 9 集', text: '群像长镜头播出，相关片段二创数量单日破万。' },
      { time: '今天上午', text: '评分回升至 8.1，平台宣布加更两集。' },
    ],
  },
  {
    id: 3,
    title: '这档音综的"救场三分钟"，成了本季播放量最高片段',
    category: '综艺名场面',
    heat: 9050,
    trend: 'new' as const,
    trendValue: '新上榜',
    comments: 3210,
    publishedAt: '1 小时前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Concert%20stage%20under%20warm%20spotlights%20with%20a%20microphone%20stand%20in%20the%20center%2C%20hazy%20amber%20and%20coral%20beams%2C%20audience%20silhouettes%20in%20the%20foreground%2C%20live%20music%20show%20key%20visual%20style%2C%20soft%20haze%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-03&orientation=landscape',
    summary:
      '伴奏突发故障的三分钟里，歌手选择清唱救场，全场安静到能听见呼吸声，这段画面在一天内被反复剪辑传播。',
    tags: ['清唱救场', '名场面', '现场'],
    author: '前排群众',
    content: [
      '当晚的录制进行到第五首时，耳返出现了明显延迟，乐队的返送也一度中断。按流程，这种状况通常会直接喊停重录，但当时已经接近下一位嘉宾的登场时间。歌手在台上停了两秒，然后向乐队比了个手势，选择清唱继续。',
      '接下来的三分钟里，现场几乎没有杂音。清唱版本把旋律和人声的距离拉得很近，几处原本被编曲盖过的高音处理反而更清楚。录制结束后，台下观众的掌声持续了将近一分钟，这段素材在正片里被完整保留。',
      '节目组随后发布的幕后提到，当时并没有刻意设计这样的桥段，是靠经验做的临场判断。这条视频在上线 24 小时内成为本季播放量最高的片段，也让"现场感"重新成为音综讨论里的关键词。',
    ],
    timeline: [
      { time: '昨晚 20:12', text: '耳返故障，歌手临时改为清唱，现场录制未中断。' },
      { time: '昨晚 23:30', text: '节目正片上线，该片段被完整保留。' },
      { time: '今天 10:00', text: '片段成为本季播放量最高内容，话题冲上热度榜前列。' },
    ],
  },
  {
    id: 4,
    title: '音乐节阵容官宣：三天预售全部秒空，票务系统再度告急',
    category: '舞台与音乐',
    heat: 8890,
    trend: 'up' as const,
    trendValue: '+7.2%',
    comments: 2980,
    publishedAt: '2 小时前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20crowd%20seen%20from%20behind%20the%20stage%2C%20warm%20sunset%20sky%20in%20coral%20and%20amber%20tones%2C%20string%20lights%20and%20flags%2C%20summer%20festival%20key%20visual%20style%2C%20soft%20grain%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-04&orientation=landscape',
    summary:
      '今年阵容公布后，三天预售在开票后短时间内告罄，多地用户反馈页面加载缓慢，主办方连夜发布抢票说明。',
    tags: ['音乐节', '预售秒空', '票务'],
    author: '瓜田小队长',
    content: [
      '阵容名单分三批公布，最后一批包含两组备受期待的乐队。名单上线的同一时间，票务页面访问量迅速攀升，不少用户在社交平台反馈"页面一直在转圈"。开票不到十分钟，首日预售显示已售完，随后两天也相继告罄。',
      '主办方在当晚发布了一份说明，解释了分时段放票的机制，并承诺后续会有少量退票回流。同时也提醒用户不要通过非正规渠道加价购票，因为实名制入场对票面信息核验会非常严格。',
      '值得注意的是，今年的阵容结构比往年更偏向独立音乐，这在讨论区引发了不小的分歧。有人认为这是主办方在试图摆脱"流量拼盘"的标签，也有人觉得多风格混搭反而更值得期待。',
    ],
    timeline: [
      { time: '昨天 12:00', text: '最后一批阵容公布，包含两组人气乐队。' },
      { time: '昨天 20:00', text: '首日预售上线，票务页面出现明显拥堵。' },
      { time: '今天 08:30', text: '三天预售全部售罄，主办方发布抢票说明。' },
    ],
  },
  {
    id: 5,
    title: '本周艺人新媒体指数出炉：前三名差距不足 0.3',
    category: '榜单数据',
    heat: 8560,
    trend: 'flat' as const,
    trendValue: '持平',
    comments: 2140,
    publishedAt: '3 小时前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20of%20ascending%20bar%20charts%20and%20glowing%20line%20graphs%20on%20a%20warm%20cream%20background%2C%20coral%20and%20amber%20highlights%2C%20minimal%20editorial%20infographic%20style%2C%20soft%20depth%20of%20field%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-05&orientation=landscape',
    summary:
      '本期指数前三名的分数咬得非常紧，任何一档综艺或一部剧的播出，都可能在下周改变排序。',
    tags: ['新媒体指数', '榜单解读', '数据'],
    author: '榜单数据员',
    content: [
      '本期指数的最大看点，是前三名之间的分差被压缩到了 0.3 以内。第一名靠着一档常驻综艺维持曝光，第二名则凭借剧集话题持续走高，第三名的声量集中在商业代言相关的讨论上。三种不同的热度来源挤在一起，让排名变得格外敏感。',
      '从细项看，第一名的优势主要在互动率，但内容产出数量略低；第二名胜在讨论广度，覆盖了多个年龄段；第三名则是搜索指数的单项领先。换句话说，谁在下周多一条有效曝光，谁就很可能完成反超。',
      '需要提醒的是，指数只是对声量的量化描述，并不等同于作品质量或公众口碑。排名靠前不代表评价更好，只能说明这一周有更多人在谈论。把它当成一个观察窗口，比当成成绩单更合适。',
    ],
    timeline: [
      { time: '本周一', text: '本期指数开始统计，覆盖 200 位活跃艺人。' },
      { time: '今天 09:00', text: '指数正式发布，前三名分差不足 0.3。' },
      { time: '下周一', text: '下一期指数将纳入本周新播剧集与综艺数据。' },
    ],
  },
  {
    id: 6,
    title: '老牌国货 × 现象级动漫联名：上线十分钟售罄，二手价翻倍',
    category: '品牌联名',
    heat: 8130,
    trend: 'up' as const,
    trendValue: '+6.1%',
    comments: 1870,
    publishedAt: '4 小时前',
    daysAgo: 0,
    cover:
      'https://readdy.ai/api/search-image?query=Flat%20lay%20of%20limited%20edition%20collaboration%20merchandise%20packaging%20with%20bold%20graphic%20patterns%20on%20a%20soft%20cream%20surface%2C%20coral%20and%20amber%20color%20accents%2C%20clean%20product%20photography%20style%2C%20soft%20natural%20light%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-06&orientation=landscape',
    summary:
      '这次联名的包装设计回归复古印刷质感，加上限量编号，让不少非粉丝也加入了抢购，二级市场溢价迅速出现。',
    tags: ['联名', '限量', '抢购'],
    author: '吃瓜实习生',
    content: [
      '联名的核心单品是一款复刻经典包装的礼盒，印刷沿用了几十年前的配色方案，并首次加入手写编号。官方在预热阶段只透露了"限量五万套"，没有公布具体发售渠道，这反而推高了关注度。',
      '开售当天，线上库存很快见底。有用户在评论区晒出订单截图，显示从下单到售罄只用了不到十分钟。随后二手平台出现了明显溢价，部分编号靠前的礼盒报价接近原价的两倍。',
      '品牌方随后回应称，不会追加相同编号的批次，但正在评估常规版本的补货计划。对普通消费者来说，如果没有抢到限量款，等待常规版本或许是更理性的选择。',
    ],
    timeline: [
      { time: '上周五', text: '官方放出预热海报，宣布限量五万套。' },
      { time: '昨天 10:00', text: '联名正式开售，线上库存十分钟内售罄。' },
      { time: '今天上午', text: '二手平台出现溢价，品牌方回应不追加同编号批次。' },
    ],
  },
  {
    id: 7,
    title: '海外颁奖礼后台花絮流出，疑似不和传闻再被翻出',
    category: '海外甜瓜',
    heat: 7780,
    trend: 'down' as const,
    trendValue: '-3.5%',
    comments: 1620,
    publishedAt: '5 小时前',
    daysAgo: 1,
    cover:
      'https://readdy.ai/api/search-image?query=Backstage%20hallway%20of%20an%20overseas%20award%20ceremony%20with%20warm%20gold%20lighting%2C%20empty%20velvet%20chairs%20and%20a%20red%20carpet%20edge%2C%20cinematic%20event%20photography%20style%2C%20amber%20and%20coral%20color%20grading%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-07&orientation=landscape',
    summary:
      '一段后台通道的短视频被解读为两人零互动，但完整版本显示，当时他们中间隔了三位工作人员，动线完全不同。',
    tags: ['颁奖礼', '后台花絮', '传闻'],
    author: '深夜瓜组',
    content: [
      '流出的片段只有短短七秒，画面里两位艺人沿着同一条通道朝相反方向走，镜头没有拍到任何交流。配文用了"全程零互动"这样的表述，很快被解读成不和传闻的"新证据"。',
      '不过随后有人放出了更完整的现场视频。从更宽的视角看，两人之间隔了三位工作人员，各自的动线本就不同，而且通道内人声嘈杂，本就不适合交谈。所谓"刻意回避"的猜测，在完整画面面前站不太住。',
      '这类由短视频片段引发的误读并不少见。画面被剪短之后，语境消失，观众很容易用已有印象去填补空白。看热闹没问题，但在转发之前多找一版完整素材，往往能省下不少误会。',
    ],
    timeline: [
      { time: '昨天 21:00', text: '七秒后台短视频流出，"零互动"说法开始扩散。' },
      { time: '昨天 23:40', text: '完整版现场视频被放出，显示两人中间隔着工作人员。' },
      { time: '今天凌晨', text: '原帖作者补充说明，话题热度回落。' },
    ],
  },
  {
    id: 8,
    title: '百万粉博主直播翻车，团队深夜回应引二次讨论',
    category: '网红圈',
    heat: 7440,
    trend: 'up' as const,
    trendValue: '+4.8%',
    comments: 2035,
    publishedAt: '6 小时前',
    daysAgo: 1,
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20streaming%20studio%20desk%20with%20a%20ring%20light%20and%20camera%20turned%20off%2C%20warm%20coral%20desk%20lamp%20glow%2C%20minimal%20creator%20workspace%20style%2C%20soft%20shadows%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-08&orientation=landscape',
    summary:
      '直播中一段口误被剪辑传播，团队当晚发出长文回应，但回应里的一句措辞又成了新的讨论焦点。',
    tags: ['直播', '回应', '剪辑争议'],
    author: '前排群众',
    content: [
      '争议源于直播里的一句口头表达。由于当时的语境是连麦互动，主播语速较快，这句话在被单独剪出后，脱离了原本的对话情境，读起来确实容易产生歧义。切片在几个小时内积累了大量转发。',
      '团队在当晚发布长文回应，解释了当时的完整对话，并对措辞不当致歉。不过回应中"我们不需要向断章取义的人解释"这一句，被不少人认为态度偏强硬，反而让讨论再度升温。',
      '从传播规律看，这属于典型的二级争议：原始事件本身不算严重，但回应方式成了新的情绪出口。后续如果选择更克制地补充说明，热度大概率会自然回落。',
    ],
    timeline: [
      { time: '昨天 20:30', text: '直播口误片段被剪辑传播，转发量快速上升。' },
      { time: '今天 01:20', text: '团队发布长文回应并致歉。' },
      { time: '今天 08:00', text: '回应中一句措辞引发二次讨论。' },
    ],
  },
  {
    id: 9,
    title: '荧幕 CP 疑似戏外成真？工作室同款文案被指"暗戳戳"',
    category: '恋情观察',
    heat: 7010,
    trend: 'new' as const,
    trendValue: '新上榜',
    comments: 1740,
    publishedAt: '7 小时前',
    daysAgo: 1,
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20cinematic%20scene%20of%20two%20coffee%20cups%20side%20by%20side%20on%20a%20warm%20cream%20table%2C%20blurred%20coral%20and%20amber%20bokeh%20lights%20in%20the%20background%2C%20romantic%20editorial%20style%2C%20shallow%20depth%20of%20field%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-09&orientation=landscape',
    summary:
      '两部剧的宣传期刚结束，两位主演工作室先后发布文案结构几乎一致的动态，被观众截图对比。',
    tags: ['荧幕CP', '文案对比', '宣传期'],
    author: '吃瓜实习生',
    content: [
      '两位演员此前合作过一部都市剧，剧中的感情线收获了不少观众。剧集收官后，双方工作室分别在相近的时间发布动态，配文的结构、标点习惯甚至换行方式都高度相似，很快有人做了并排截图。',
      '支持"成真"的一方认为，这种一致性很难用巧合解释；持保留态度的一方则指出，两位演员共用同一家宣传团队，文案模板相同其实是行业常见做法。双方各执一词，讨论热度稳步上升。',
      '截至目前，双方都没有就此事做出任何回应。从内容本身看，这些动态都只是常规的剧集宣传收尾，把它当作恋爱证据，证据链确实偏薄。',
    ],
    timeline: [
      { time: '前天', text: '剧集正式收官，两位主演分别发文告别角色。' },
      { time: '昨天下午', text: '工作室动态被指文案结构一致，对比图开始流传。' },
      { time: '今天', text: '话题进入热度榜前十，双方暂未回应。' },
    ],
  },
  {
    id: 10,
    title: '悬疑剧大结局评分两极：编剧亲自下场解释伏笔',
    category: '影视风向',
    heat: 6690,
    trend: 'down' as const,
    trendValue: '-5.2%',
    comments: 1520,
    publishedAt: '9 小时前',
    daysAgo: 2,
    cover:
      'https://readdy.ai/api/search-image?query=Moody%20night%20street%20in%20warm%20dim%20streetlamp%20light%2C%20rain%20slick%20pavement%20reflecting%20amber%20glow%2C%20mystery%20thriller%20poster%20mood%20style%2C%20coral%20accent%20in%20the%20distance%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-10&orientation=landscape',
    summary:
      '结局播出后观众分裂成两派，一派认为留白高级，一派觉得线索没收；编剧在社交平台逐条回应了七个关键伏笔。',
    tags: ['悬疑剧', '大结局', '伏笔解析'],
    author: '老瓜观察员',
    content: [
      '这部剧从开播起就以"每集埋一个反转"著称，观众也习惯了边看边做笔记。因此当大结局选择以一种相对开放的方式收尾时，长期追剧的观众产生了明显的分裂。',
      '认可的一方认为，结局把最关键的动机留给了观众，符合整部剧的气质；反对的一方则列出了七处没有交代清楚的线索，认为留白和没收尾是两回事。评分在更新后的两小时内出现了明显的波动。',
      '编剧随后在个人账号上逐条回应了这些疑问，其中三条属于"确实有拍但被剪掉"的内容，另外四条则解释为刻意的信息差。这份回应没有让争议平息，但至少让讨论从情绪转向了具体的情节分析。',
    ],
    timeline: [
      { time: '前天 20:00', text: '大结局上线，开放收尾引发两极评价。' },
      { time: '前天 23:10', text: '有观众整理出七处未回收线索，长文被广泛转发。' },
      { time: '昨天 15:00', text: '编剧逐条回应伏笔，其中三条为剪辑原因。' },
    ],
  },
  {
    id: 11,
    title: '素人嘉宾一句话冲上热搜，节目组连夜宣布加更',
    category: '综艺名场面',
    heat: 6320,
    trend: 'up' as const,
    trendValue: '+3.9%',
    comments: 1280,
    publishedAt: '11 小时前',
    daysAgo: 2,
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20living%20room%20set%20of%20a%20reality%20show%20with%20soft%20amber%20lamp%20light%2C%20empty%20sofa%20and%20mugs%20on%20the%20table%2C%20cozy%20variety%20show%20style%2C%20coral%20cushion%20accents%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-11&orientation=landscape',
    summary:
      '不做作的一句真心话让这位素人嘉宾圈粉无数，节目的评论区从"看剧情"变成了"看人"。',
    tags: ['素人嘉宾', '一句话', '加更'],
    author: '深夜瓜组',
    content: [
      '在这类生活观察节目里，素人嘉宾往往容易被剪成功能性角色，负责推动剧情或者在观察室里被点评。但这一期里，这位嘉宾的一段诉说几乎没有任何修饰，把长期积压的情绪讲得相当平静，反而格外打动人。',
      '节目播出后，相关内容在社交平台迅速扩散。评论区里出现了大量"像在听朋友说话"的留言，也有观众表示，正是这种不刻意煽情的表达，让节目找回了最初的质感。',
      '节目组随后宣布加更两期，并说明会保留更多嘉宾的日常片段。对一档已经播到中段的节目来说，这样的临时调整并不多见。',
    ],
    timeline: [
      { time: '前天 21:00', text: '最新一期播出，素人嘉宾片段引发共鸣。' },
      { time: '前天 23:30', text: '相关话题进入热搜讨论区，二创视频增多。' },
      { time: '昨天 10:00', text: '节目组宣布加更两期并调整剪辑方向。' },
    ],
  },
  {
    id: 12,
    title: '巡回演唱会加场公布，粉丝应援口号意外出圈',
    category: '舞台与音乐',
    heat: 5980,
    trend: 'flat' as const,
    trendValue: '持平',
    comments: 1105,
    publishedAt: '13 小时前',
    daysAgo: 2,
    cover:
      'https://readdy.ai/api/search-image?query=Sea%20of%20warm%20coral%20and%20amber%20glow%20sticks%20in%20a%20dark%20arena%2C%20blurred%20crowd%20silhouettes%20facing%20an%20empty%20stage%2C%20concert%20atmosphere%20key%20visual%2C%20soft%20haze%20and%20bokeh%2C%20clean%20composition%2C%20no%20text%2C%20high%20detail&width=800&height=560&seq=gua-cover-12&orientation=landscape',
    summary:
      '巡演宣布新增四站后，一段现场应援视频被路人反复转发，连不看演唱会的人都说"莫名被感染"。',
    tags: ['演唱会', '加场', '应援'],
    author: '瓜田小队长',
    content: [
      '巡演原定的城市在开票阶段就已经全部售罄，主办方在演出进行到一半时宣布新增四站。加场消息发布后，讨论量并没有集中在票务上，而是集中在现场观众的一段应援视频。',
      '视频里，全场在某个间奏段落自发接上了同一句口号，节奏整齐到几乎不需要指挥。拍摄者是坐在后排的路人，他在配文里写道，自己本来只是陪朋友来，结果被这段气氛带动着一起喊。',
      '这段视频的出圈，也带火了一个老话题：现场演出最珍贵的，往往不是某一次完美的演唱，而是一群人同时产生共鸣的那几秒。对很多观众来说，这大概就是愿意反复走进场馆的理由。',
    ],
    timeline: [
      { time: '前天 19:30', text: '巡演加场四站消息公布，票务预约量快速上升。' },
      { time: '昨天', text: '路人拍摄的应援视频被大量转发，话题出圈。' },
      { time: '今天', text: '主办方提醒加场开票时间，热度保持平稳。' },
    ],
  },
];